// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1IEXw","actions":"GroupTable_actions__3OlZx","deleteModalFooter":"GroupTable_deleteModalFooter__3FTzV"};